// extracted by mini-css-extract-plugin
export var content = "_ne-1";
export var noScroll = "_ne-3";
export var paper = "_ne-0";
export var scrollable = "_ne-2";